import {
  createApiRef,
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { ExtensionManagerApi } from '@agilelab/plugin-wb-extension-manager-common';

import { testPolicyPageRef, rootRouteRef } from './routes';

export const wbExtensionManagerPlugin = createPlugin({
  id: 'wb-extension-manager',
  routes: {
    root: rootRouteRef,
  },
  externalRoutes: {
    policyPage: testPolicyPageRef,
  },
});

/**
 * The API reference for the ExtensionManagerApi.
 * @public
 */
export const extensionManagerApiRef = createApiRef<ExtensionManagerApi>({
  id: 'plugin.extension-manager',
});

export const WbExtensionManagerPage = wbExtensionManagerPlugin.provide(
  createRoutableExtension({
    name: 'WbExtensionManagerPage',
    component: () => import('./components/Router').then(m => m.Router),
    mountPoint: rootRouteRef,
  }),
);
